import { createAsyncThunk } from "@reduxjs/toolkit";

import PhysicalTechnicalVerificationsAPI, {
  MessageResponse,
  GetPTVerificationsResponse,
  UpsertPTVerificationsParams,
} from "../../../api/physicalTechnicalVerifications";
import { RootState } from "../../../app/store";

export const fetchPTVerifications = createAsyncThunk<
  GetPTVerificationsResponse,
  string,
  { state: RootState; rejectValue: string }
>(
  "physicalTechnicalVerifications/fetchPTVerifications",
  async (caseId, { rejectWithValue }) => {
    try {
      const response =
        await PhysicalTechnicalVerificationsAPI.getPTVerifications({
          case_id: caseId,
        });

      return response;
    } catch {
      return rejectWithValue(
        "Failed to fetch physical technical verifications",
      );
    }
  },
  {
    condition(caseId, { getState }) {
      const ptVerificationsState = getState().physicalTechnicalVerifications;

      if (
        ptVerificationsState.caseId === caseId &&
        (ptVerificationsState.status === "loading" ||
          ptVerificationsState.status === "success")
      ) {
        return false;
      }

      return true;
    },
  },
);

export const upsertPTVerifications = createAsyncThunk<
  MessageResponse,
  UpsertPTVerificationsParams,
  { rejectValue: string }
>(
  "physicalTechnicalVerifications/upsertPTVerifications",
  async (params, { rejectWithValue }) => {
    try {
      const response =
        await PhysicalTechnicalVerificationsAPI.upsertPTVerifications(
          params,
        );

      return response;
    } catch {
      return rejectWithValue(
        "Failed to save physical technical verifications",
      );
    }
  },
);